import ApiService from "../api.service";
import appConfig from "../../../app-config";

ApiService.init(appConfig.VUE_APP_ROOT_API);

const AlmondcoGrowerDetailService = {
  // technical-design.md §5/AD-01: no GetById route - $filter on SupplierCode
  // is the only way to key one on. An empty result array means "no Grower
  // Detail row yet", not an error.
  async getGrowerDetail(supplierCode) {
    return await ApiService.get(
      `api/AlmondcoGrowerDetail?$filter=SupplierCode eq '${supplierCode}'`
    );
  },

  // §5: single unconditional upsert, no create/update split (BR-02 - resolved
  // server-side inside the reused write procedure) - matches
  // AlmondcoGrowerSyndicateSplitService's own saveGrowerSplit shape exactly.
  async saveGrowerDetail(payload) {
    return await ApiService.post("api/Save_AlmondcoGrowerDetail", payload);
  },

  // §6/BR-07: no active-only filter - carried forward from legacy as-is.
  async getGrowerRegions() {
    return await ApiService.get("api/AlmondcoGrowerRegions");
  },

  // §6/BR-06: Price Scheme lookup restricted to a single season - a small,
  // bounded result set (not the unfiltered all-history shape the Scheme
  // Prices List screen moved away from for scaling reasons), so deriving
  // distinct SchemeId values client-side (in the component) remains
  // appropriate here.
  async getSchemePricesForSeason(seasonYear) {
    return await ApiService.get(
      `api/AlmondcoSchemePrice?$filter=SeasonYear eq ${seasonYear}&$select=SchemeId`
    );
  },

  // §5/BR-09/BR-11: fixed matrix - always one row per active Huller/Cracker
  // site, whether or not an association already exists yet for this Grower
  // (nullable DollarsPerKg/Status/RecordId on a no-association row).
  async getHullerAssociations(supplierCode) {
    return await ApiService.get(
      `api/AlmondcoGrowerHullerAssociation?$filter=GrowerCode eq '${supplierCode}'`
    );
  },

  // "Current FY" resolution - duplicated here rather than imported from
  // almondco-scheme-price.service.js, matching this project's established
  // one-service-file-per-screen convention (three sibling files already
  // duplicate this identically rather than sharing it).
  async getIntakeSeasons() {
    return await ApiService.get(
      "api/AlmondcoIntakeSeason?$select=Season,StartDate,EndDate&$orderby=Season desc"
    );
  },
};

export { AlmondcoGrowerDetailService };
